module.exports = {"apiBaseUrl":"https://abledev.ineqe.com/","BaseUrl":"https://abledev.ineqe.com/","isDebug":true};


// WEBPACK FOOTER //
// external "{/"apiBaseUrl/":/"https:/abledev.ineqe.com//",/"BaseUrl/":/"https:/abledev.ineqe.com//",/"isDebug/":true}"